import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

//MUI Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Alert from '@mui/material/Alert';

//created components
import TailleCycliste from '../taillecycliste/TailleCycliste.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getPanier, getStockArticles } from "../../../../store/selectors.js"; //global state : shopping state
import { panierSlice } from "../../../../store/panierSlice.js";

//Utils :
import { calcPrix, calcPrixDegressif } from "../../../../utils/calcul_prix.js"

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

// // // pop up MUI dialog image
function ImageDialog({ onClose, open, src }) {

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <img src={src} className="image-dialog" onClick={() => onClose()} />
        </Dialog>
    );
}
// // // End Mui Dialog



function ShoppingArticle({ article, duree }) { // component to manage the first step of shopping : choosing place and time


    let panier = useSelector(getPanier);
    const lang = useSelector(getLang) //global state : language
    const stockA = useSelector(getStockArticles) //global state : stocks
    const dispatch = useDispatch();
    const [stockRestant, setStockRestant] = useState(article.stock - getQteLoues(article));
    //console.log("restant", stockRestant);

    useEffect(() => {
        setStockRestant(article.stock - getQteLoues(article) - getQte());
    }, [panier, stockA]);

    function getQteLoues(article) {
        let qte = 0;
        if (stockA.length > 0) {
            qte = stockA.find(art => art.article_id === article.id_article).qte;
        }
        return qte;
    }

    function getQte() {
        let currentArticle = panier.filter((ligne) => ligne.id_article === article.id_article)
        if (currentArticle.length > 0) {//"ligne" represent an article in the panier
            return (currentArticle[0].qte);
        }
        else {
            return (0);
        }
    }

    function handleChangeQte(delta) {
        let qte = getQte();

        if (qte === 0) { //article non present in panier
            if (delta === "plus") { //add new article
                dispatch(panierSlice.actions.newArticle(article));
            }
        }// end of new article

        if (qte === 1) { //jusT 1 article  present in panier
            if (delta === "plus") { //increment article
                dispatch(panierSlice.actions.incrementArticle(article));
            }
            if (delta === "moins") { //remove  article
                dispatch(panierSlice.actions.removeArticle(article));
            }
        }

        if (qte > 1) { //jusT 1 article  present in panier
            if (delta === "plus") { //increment article
                dispatch(panierSlice.actions.incrementArticle(article));
            }
            if (delta === "moins") { //decrement  article
                dispatch(panierSlice.actions.decrementArticle(article));
            }
        }



    }


    function getTaillesCyclistes() {
        let listCyclistes = [];
        let currentArticle = panier.filter((ligne) => ligne.id_article === article.id_article)
        if (currentArticle.length > 0) {//"ligne" represent an article in the panier
            //console.log(currentArticle[0].qte)
            for (let i = 0; i < currentArticle[0].qte; i++) {
                //listCyclistes.push({ taille: currentArticle[0].tailles[i], prenom: currentArticle[0].prenoms[i] })
                let cycliste = { taille: currentArticle[0].tailles[i], prenom: currentArticle[0].prenoms[i] }
                listCyclistes.push(<TailleCycliste key={i} index={i} id_article={article.id_article} />)
            }
        }
        return listCyclistes;

    }

    // -- To manage image modal

    ImageDialog.propTypes = {
        open: PropTypes.bool.isRequired,
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    // -- end of image modal

    function displayDiscount(qte) {
        let discountInfo = "";
        if (calcPrix(article.Tarif, duree) > calcPrixDegressif(article.Tarif, duree)) {
            discountInfo += " au lieu de " + calcPrix(article.Tarif, duree) * qte + ",00€";
        }

        return discountInfo;
    }


    return (
        <div className={getQte() > 0 ? "cadre-article cadre-access-selected" : "cadre-article "}>
            <div className="cadre-article-left">
                <div className="cadre-article-left-top">
                    <img src={article.image_url} alt="image vélo" onClick={_ => handleClickOpen()} />
                </div>

                <ImageDialog
                    open={open}
                    onClose={handleClose}
                    src={article.image_url}
                />


                <div className="cadre-article-left-bottom">
                    <div className="boutons-qte">
                        <Button
                            /* disabled={dsbld} */
                            variant="contained"
                            /* onClick={nextStep} */
                            className="boutons-qte-moins" //stylise in css
                            style={{ maxWidth: '50px', maxHeight: '36px', minWidth: '50px', minHeight: '36px' }}
                            onClick={() => { handleChangeQte("moins") }}
                        > - </Button>
                        <p className="boutons-qte-valeur">{getQte()}</p>
                        <Button
                            disabled={stockRestant < 1}
                            variant="contained"
                            /* onClick={nextStep} */
                            className="boutons-qte-plus" //stylise in css
                            style={{ maxWidth: '50px', maxHeight: '36px', minWidth: '50px', minHeight: '36px' }}
                            onClick={() => { handleChangeQte("plus") }}
                        > + </Button>

                    </div>
                </div>
            </div>
            <div className="cadre-article-center">
                <div className="cadre-article-center-top">
                    <div className="cadre-article-center-top-titre">
                        <h3>{article.type}</h3>

                    </div>
                    <div className="cadre-article-center-top-description">
                        <h4>{article.infos}</h4>
                        <p className="cadre-article-center-top-description-infos2">{article.infos2}</p>
                        <p className="cadre-article-center-top-description-description">{article.description}</p>
                        {stockRestant < 5 && stockRestant > 0 ? <Alert className="cadre-article-center-top-alert" severity="warning">{translator("moins de 5 articles disponibles pour cette période", lang, "shoppingArticleStock5")}</Alert> : null}
                        {stockRestant <= 0 ? <Alert className="cadre-article-center-top-alert" severity="error">{translator("plus d'article disponible pour cette période ", lang, "shoppingArticleStock0")}</Alert> : null}

                    </div>
                </div>
                <div className="cadre-article-center-bottom">
                    <div className="cadre-article-center-bottom-haut">
                        <p className="cadre-article-center-bottom-infos-taille">{translator("Taille :", lang, "shoppingArticleTaille")}{article.taille === "unique" ? "unique" : article.taille}</p>

                        <p className="cadre-article-center-bottom-infos-garantie">{getQte() > 0 ? ` ${translator("Valeur de la garantie demandée :", lang, "shoppingArticleGarantie")} ${getQte() * article.caution},00€` : null}</p>
                    </div>
                    <div className="cadre-article-center-bottom-main">
                        <h3>{getQte() > 0 ? calcPrixDegressif(article.Tarif, duree) * getQte() + ",00€" : null}</h3>
                        <p>{getQte() > 0 ? translator("à régler pour cette période", lang, "shoppingArticleARegler") + `${displayDiscount(getQte())}` : null}</p>
                    </div>
                </div>
            </div>
            <div className={article.taille !== "unique" && getQte() > 0 ? "cadre-article-right" : "cadre-article-right-hidden"} >
                <div className="cadre-article-right-top">
                    <p>{translator("Tailles des cyclistes :", lang, "shoppingArticleCyclistes")}</p>
                </div>
                <div className="cadre-article-right-bottom"> {getTaillesCyclistes()} </div>
            </div>


        </div>

    )
}




export default ShoppingArticle